var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "casino-favorites-container",
      on: {
        click: function($event) {
          return _vm.addOrRemoveFromFavorites()
        }
      }
    },
    [
      !_vm.localFavorite
        ? _c("span", { staticClass: "casino-favorites-icon-empty" })
        : _vm._e(),
      _vm._v(" "),
      _vm.localFavorite
        ? _c("span", { staticClass: "casino-favorites-icon-full" })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c672b4c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c672b4c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/igaming/partials/casinoFavorites.vue
// module id = null
// module chunks = 